import React from "react";
import { Box, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../../assets/Frame 1410104064.svg";
export default function BrandSideLogo() {
  const navigate = useNavigate();
  const location = useLocation();

  const hideBackButtonRoutes = ["/customer/auth/login", "/vendor/auth/login"];
  const showBackButton = !hideBackButtonRoutes.includes(location.pathname);
  
  const handleNavigate = () => {
    if(location.pathname === "/customer/auth/login" || location.pathname === "/vendor/auth/login"){
      navigate("/");
    }else if(location.pathname === "/customer/auth/register"){
      navigate("/customer/auth/login");
    }else if(location.pathname === "/vendor/auth/register"){
      navigate("/vendor/auth/login");
    }else{
      navigate(-1); // Go back one page in the browser's history
    }
  };

  return (
    <Box
      flex={1}
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        background: "linear-gradient(135deg, #6a00f4, #6f6df8)",
        padding: 4,
        height: "100vh",
        position: "relative",
        width: "100%",
      }}
    >
      {/* {showBackButton && ( */}
      {
        <IconButton
          onClick={handleNavigate}
          sx={{
            position: "absolute",
            top: 16,
            left: 16,
            color: "#6a00f4",
            bgcolor: "rgba(242, 190, 34, 0.94)",
            "&:hover": {
              bgcolor: "rgba(248, 199, 77, 0.37)",
            },
          }}
        >
          <ArrowBackIcon />
        </IconButton>
      }

      <img src={logo} alt="hbn logo" style={{ width: "200px" }} />
    </Box>
  );
}
